import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';

export class ApplicationSettingsModel {
    RoleId: number;
    ApplicationSettingType: ApplicationSettingsType;
    AccessRightType: AccessRightType;
    AccessRightTypes: AccessRightType[];
    Disabled: boolean;

    constructor(
        roleId: number,
        applicationSettingType: ApplicationSettingsType,
        accessRightType: AccessRightType,
        accessRightTypes: AccessRightType[],
    ) {
        this.RoleId = roleId;
        this.ApplicationSettingType = applicationSettingType;
        this.AccessRightType = accessRightType || AccessRightType.UnAvailable;
        this.AccessRightTypes = accessRightTypes;
    }
}
